import { Grid, makeStyles, Theme, Typography } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    borderTop: '2px solid #000',
    marginBottom: '77px',
    [theme.breakpoints.down('md')]: {
      borderTop: '1px solid #dcdcdc',
    },
  },
  border: {
    border: '1px solid tomato',
  },
  row: {
    height: '55px',
    display: 'flex',
    fontSize: '14px',
    color: '#000',
    borderBottom: '1px solid #D5D5D5',
    '&:hover': {
      backgroundColor: '#F7F7F7',
    },
    [theme.breakpoints.down('md')]: {
      height: '88px',
      alignItems: 'center',
    },
  },
  headerContainer: {
    width: '100%',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  headerColumn: {
    // display: 'inline-block',
    height: '100%',
    textAlign: 'center',
    // lineHeight: 4.5,
    paddingTop: '15px',
    paddingBottom: '15px',
    // border: '1px solid #b4b4b4',
    // flexBasis: 0,
    // flexGrow: 0,
    '&:not(:last-child)': {
      borderRight: '1px solid #b4b4b4',
      // border: '1px solid #b4b4b4',
    },
    '&:nth-child(1)': {
      // flex: '128px',
      flexBasis: '128px',
      flexGrow: 0,
    },
    '&:nth-child(2)': {
      // flex: '135px',
      flexBasis: '145px',
      flexGrow: 0,
    },
    '&:nth-child(3)': {
      // flex: '360px',
      flexBasis: '370px',
      flexGrow: 0,
    },
    '&:nth-child(4)': {
      // flex: '145px',
      flexBasis: '156px',
      flexGrow: 0,
    },
    '&:nth-child(5)': {
      // flex: '145px',
      flexBasis: '155px',
      flexGrow: 0,
    },
    '&:nth-child(6)': {
      // flex: '100px',
      flexBasis: '110px',
      flexGrow: 0,
    },
    '&:nth-child(7)': {
      // flex: '95px',
      flexBasis: '134px',
      flexGrow: 0,
    },
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      '&:nth-child(1)': {
        height: '100%',
        minWidth: 0,
        flex: 1,
        borderLeft: '1px solid #dcdcdc',
        borderRight: 0,
        textAlign: 'left',
        padding: '5px 20px',
      },
      '&:nth-child(2)': {
        flex: '0 0 20px',
      },
    },
  },
  alignLeftColumn: {
    '& > div': {
      // display: 'flex',
      // justifyContent: 'space-around',
      // alignItems: 'center',
      // border: '1px solid tomato',
      // height: '100%',
      textAlign: 'left',
      paddingLeft: '25px',
      paddingRight: '25px',
    },
  },
  rowContainer: {
    // width: '100%',
    // height: '50px',
    // borderBottom: '1px solid #b4b4b4',
    // '&:hover': {
    //   backgroundColor: theme.palette.grey[100],
    // },
  },
  numberContainer: {
    // width: '5%',
  },
  seasonContainer: {
    // width: '10%',
  },
  typeContainer: {
    // width: '10%',
  },
  titleContainer: {
    // width: '30%',
  },
  teamContainer: {
    // display: 'inline-block',
    // width: '15%',
    // height: '100%',
    // textAlign: 'left',
    // overflow: 'hidden',
    // textOverflow: 'ellipsis',

    '& > div': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      // height: '100%',
      '& > img': {
        maxHeight: '20px',
        marginRight: '5px',
      },
      '& > span': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
  },
  gameDateContainer: {
    [theme.breakpoints.down('md')]: {
      fontSize: '11px',
      color: '#999',
    },
  },
  menuContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  verticalColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  verticalBorder: {
    backgroundColor: '#dcdcdc',
  },
  textEllipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));
